/** Every store information page: its URL, footer column and text. Routes and the footer come from here. */
import { about } from "./docs/about";
import { buyingGuide } from "./docs/buyingGuide";
import { contact } from "./docs/contact";
import { cookies } from "./docs/cookies";
import { help } from "./docs/help";
import { privacy } from "./docs/privacy";
import { refunds } from "./docs/refunds";
import { shipping } from "./docs/shipping";
import { terms } from "./docs/terms";
import { marketTerms } from "./docs/marketTerms";
import type { InfoDoc } from "./types";

export type InfoGroup = "legal" | "resources";

export interface InfoPageDef {
  path: string;
  group: InfoGroup;
  doc: InfoDoc;
  /** Legal texts show their "last updated" date. */
  dated: boolean;
}

export const INFO_PAGES: InfoPageDef[] = [
  { path: "/reembolsos", group: "legal", doc: refunds, dated: true },
  { path: "/cookies", group: "legal", doc: cookies, dated: true },
  { path: "/terminos", group: "legal", doc: terms, dated: true },
  { path: "/privacidad", group: "legal", doc: privacy, dated: true },
  { path: "/mercado/terminos", group: "legal", doc: marketTerms, dated: true },
  { path: "/guia-de-compra", group: "resources", doc: buyingGuide, dated: false },
  { path: "/envios", group: "resources", doc: shipping, dated: false },
  { path: "/ayuda", group: "resources", doc: help, dated: false },
  { path: "/nosotros", group: "resources", doc: about, dated: false },
  { path: "/contacto", group: "resources", doc: contact, dated: false },
];
